import React from 'react';
import Typography from '@mui/material/Typography';

const Pay = () => {
    return (
        <div>
            <Typography sx={{ mt: 8 }} variant="h3" gutterBottom component="div">
                PayMent Method Comming Soon
            </Typography>
        </div>
    );
};

export default Pay;